import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgParkeren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85E3F9"
      d="M29 6H11v26h18z"
    />
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M20 12a5 5 0 0 1 0 10h-2v5h-3V12zm0 3h-2v4h2a2 2 0 1 0 0-4"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgParkeren);

export default ForwardRef;
